import $router from "../common/uni-router"
import { Volcengine } from "../common"
export default class UniVolcengine extends Volcengine {
  constructor(params) {
    params.type = 0 // 表示是uni-app 端的SDK
    super(params)
    try {
      this.uniPluginObject = params.uniPluginObject
      this.routerInfo = UNI_ROUTES.pages
      this.tarBar = UNI_ROUTES.tarBar ? UNI_ROUTES.tarBar.list : []
      this.isVolcengine = true
    } catch (e) {
      this.isVolcengine = false
      this.routerInfo = []
      this.tarBar = []
    }
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
  }
  start() {
    if (!this.isVolcengine) {
      return
    }
    this.init(this.routerInfo, this.tarBar)
  }
  // 监听路由变化
  listenRouter(param) {
    if (!param || Object.prototype.toString.call(param) !== "[object Object]") {
      param = {}
    }
    $router.onchange = (n, o) => {
      if (!this.isVolcengine) {
        return
      }
      try {
        const lastVisitUrl = this.getCacheVisitUrl()
        const nowPath = n.fullPath
        if (lastVisitUrl === nowPath) {
          return
        }
        this.setCacheVisitUrl(nowPath)
        const lastPageVisitTime = this.getCacheTime()
        const nowTime = new Date().getTime()
        this.setCacheTime(nowTime)

        if (!this.volcengineProps[nowPath]) {
          this.updateRouter(this.routerInfo, this.tarBar)
        }
        let commonAttr = this.getCommonAttr(nowPath)
        const durationParam = {
          custom_page_duration: nowTime - lastPageVisitTime
        }
        const finalParam = {
          ...commonAttr,
          ...durationParam,
          ...param
        }
        this.uniPluginObject.onEventV3("custom_pageview", finalParam)
      } catch (e) {}
    }
  }
  /**
   * 上报火山引擎唯一的用户id 登录传id 退出的时候传null或空字符串
   * @param {*} paramUserUniqueId 要上报的火山用户唯一ID
   * @returns
   */
  setUserUniqueId(paramUserUniqueId) {
    if (!this.isVolcengine) {
      return
    }
    const userUniqueId = paramUserUniqueId || this.nullProp
    try {
      this.uniPluginObject.setUserUniqueId(userUniqueId)
    } catch (e) {}
  }
  // 获取uni-app的插件
  getuniPluginObject() {
    return this.uniPluginObject
  }
  // 获取项目是否接入了火山SDK
  getIsVolcengine() {
    return this.isVolcengine
  }
  /**
   * 上报接口埋点
   * @param {Object} param
   */
  collectApi(param) {
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
    const currentUrl = this.pages[0]
    let commonAttr = this.getCommonAttr(currentUrl)
    const apiParam = {
      api_name: param.apiName, // 接口名称
      is_success: param.isSuccess, // 是否成功
      api_time_cost: param.apiTimeCost // 接口请求耗费的时间
    }
    let finalParam = {
      ...commonAttr,
      ...apiParam
    }
    delete param.apiName
    delete param.isSuccess
    delete param.apiTimeCost
    finalParam = {
      ...finalParam,
      ...param
    }
    try {
      this.uniPluginObject.onEventV3("api_request", finalParam)
    } catch (e) {}
  }
  // 监听初始化进入页面
  customPageviewOpen(param) {
    if (!param || Object.prototype.toString.call(param) !== "[object Object]") {
      param = {}
    }
    try {
      let currentUrl
      if (this.pages.length > 0) {
        currentUrl = this.pages[0]
      } else {
        // 获取不到当前页面只能获取上一次访问的
        currentUrl = this.getCacheVisitUrl()
      }
      // 如果没有任何匹配的，那就是首页
      if (!currentUrl) {
        currentUrl = "/" + this.routerInfo[0].path
      }
      this.setCacheVisitUrl(currentUrl)
      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      const commonAttr = this.getCommonAttr(currentUrl)
      const finalParam = {
        ...commonAttr,
        ...param
      }
      this.uniPluginObject.onEventV3("custom_pageview_open", finalParam)
      const customPageViewParam = {
        ...finalParam,
        custom_page_duration: 0
      }
      this.uniPluginObject.onEventV3("custom_pageview", customPageViewParam)
    } catch (e) {}
  }
  /**
   * 监听隐藏页面
   * @param
   * @returns
   */
  customPageviewHide(param) {
    try {
      if (
        !param ||
        Object.prototype.toString.call(param) !== "[object Object]"
      ) {
        param = {}
      }
      const pages = this.getCurrentPagesArr()
      this.changeCurrentPage(pages)
      let currentUrl = this.getCacheVisitUrl()
      if (this.pages.length > 0) {
        currentUrl = this.pages[0]
      }
      // 如果没有任何匹配的，那就是首页
      if (!currentUrl) {
        currentUrl = "/" + this.routerInfo[0].path
      }
      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      const commonAttr = this.getCommonAttr(currentUrl)
      const finalParam = {
        ...commonAttr,
        ...param
      }

      this.uniPluginObject.onEventV3("custom_pageview_hide", finalParam)
    } catch (e) {}
  }
  /**
   * 用户上报火山自定义事件
   * @param {*} name 自定义的事件名称
   * @param {*} param 自定义的事件参数
   * @returns
   */
  reportEvent(name, param) {
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
    const currentUrl = this.pages[0]
    let commonAttr = this.getCommonAttr(currentUrl)
    const finalParam = {
      ...commonAttr,
      ...param
    }
    try {
      this.uniPluginObject.onEventV3(name, finalParam)
    } catch (e) {}
  }
  /**
   * 设置用户属性
   * @param {*} profileParam 用户属性
   * @returns
   */
  profileSet(profileParam) {
    try {
      this.uniPluginObject.profileSet(profileParam)
    } catch (e) {}
  }

  getSdkVersion() {
    try {
      const versionInfo = this.getVersionInfo()
      return {
        user_analytics_sdk_version_name:
          versionInfo["analytics_sdk_version_name"]
      }
    } catch (e) {
      return {
        user_analytics_sdk_version_name: ""
      }
    }
  }

  getAppVersion() {
    try {
      const versionInfo = this.getVersionInfo()
      return {
        user_custom_app_version_name: versionInfo["custom_app_version_name"]
      }
    } catch (e) {
      return {
        user_custom_app_version_name: ""
      }
    }
  }
  sdkVersionProfileSet(param) {
    try {
      const sdkVersion = this.getSdkVersion()
      const finalParam = {
        ...param,
        ...sdkVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  appVersionProfileSet(param) {
    try {
      const appVersion = this.getAppVersion()
      const finalParam = {
        ...param,
        ...appVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }
}
